import { render } from "./num-ani.vue?vue&type=template&id=39a1bad4"
import script from "./num-ani.vue?vue&type=script&lang=js"
export * from "./num-ani.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\sns\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__